import { useTranslation } from 'react-i18next';

const Loading = () => {
  const { t, ready } = useTranslation(undefined, { useSuspense: false });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-100/20 backdrop-blur backdrop-filter dark:bg-slate-900/20">
      <svg
        className="h-6 w-6 animate-spin text-purple-500 dark:text-purple-400"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-50"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <span className="sr-only">
        {!ready ? 'Loading' : t('loading')}&hellip;
      </span>
    </div>
  );
};

export default Loading;
